import { Badge, Space } from 'antd'
import { CIMSBadgeProps } from './types'
import { useEffect } from 'react'

const CIMSBadge: React.FC<CIMSBadgeProps> = ({
  count,
  backgroundColor,
  children,
  onCountChange,
  ...rest
}) => {
  useEffect(() => {
    onCountChange?.(count)
    // callbacks in use effect typically cause infinite re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count])
  if (!rest.showZero && (count === undefined || count === 0))
    return <>{children}</>
  return (
    <Space size="small" align="center">
      <Badge
        {...rest}
        count={count ?? 0}
        style={{ backgroundColor: backgroundColor ?? '#1890ff' }}
      />
      {children}
    </Space>
  )
}

export default CIMSBadge
